import { DeferredPromise } from '@open-draft/deferred-promise'

export type Deferred<Input, Output = Input> = DeferredPromise<Input, Output>

export function deferred<T>(): Deferred<T> {
	return new DeferredPromise<T>()
}
